import type { EnhancedLiveChatConfig } from '#types/config/integrations/livechat'

export default {
  cssPath: '/livechat/css/LiveChatCodeCanvasTBL.css',
  brand: 'TBL',
  languageConfig: {
    'da-dk': 'en_US',
    'de-at': 'de',
    'de-be': 'de',
    'de-ch': 'de',
    'de-de': 'de',
    'de-lu': 'de',
    'en-ch': 'en_US',
    'en-dk': 'en_US',
    'en-ie': 'en_US',
    'en-se': 'en_US',
    'es-es': 'es',
    'es-us': 'es',
    'fr-be': 'fr',
    'fr-ch': 'fr',
    'fr-fr': 'fr',
    'fr-lu': 'fr',
    'it-ch': 'it',
    'it-it': 'it',
    'nl-be': 'nl_NL',
    'nl-lu': 'nl_NL',
    'nl-nl': 'nl_NL',
    'pl-pl': 'pl',
    'pt-pt': 'pt_PT',
    'sv-se': 'en_US'
  },
  eswConfigDevName: 'MIAW_TBL'
} satisfies EnhancedLiveChatConfig
